export function useMasterSteps() {
  const { staticUrl } = useRuntimeConfig().public;
  return [
    {
      title: 'Пройди регистрацию',
      subtitle:
        'Пройди регистрацию за 2 минуты. Введи номер телефона и получи код',
      screenImageUrl: `${staticUrl}/landing/partner-step1.jpg`,
      tips: [
        {
          text: 'Введи номер телефона и получи код',
          top: '10%',
          left: '70%',
        },
      ],
    },
    {
      title: 'Заполни профиль',
      subtitle:
        'Клиентам интересно знать больше: расскажи про себя, свой опыт и услуги в рабочем графике',
      screenImageUrl: `${staticUrl}/landing/partner-step2.jpg`,
      tips: [
        {
          text: 'Расскажи про себя, свой опыт и услуги',
          top: '-5%',
          left: '60%',
        },
      ],
    },
    {
      title: 'Начни зарабатывать',
      subtitle: 'Клиент сам найдет тебя при поиске услуги',
      screenImageUrl: `${staticUrl}/landing/partner-step3.jpg`,
      tips: [
        {
          text: 'Клиент сам найдет тебя при поиске услуги',
          top: '35%',
          left: '50%',
        },
      ],
    },
  ];
}
